class BundleBuilder extends HTMLElement {
  constructor() {
    super();
    this.bundleSize = 3;
    this.isSubscription = true;
    this.bundleContents = {};
    this.bundleQuantity = 0;
    this.finalPrice = 21.60;
    this.basePrice = 8 * this.bundleSize;
  }

  connectedCallback() {
    this.bundleSizeRadios = this.querySelectorAll('input[name="bundle-size"]');
    this.purchaseTypeRadios = this.querySelectorAll('input[name="purchase-type"]');
    this.productCards = this.querySelectorAll('.product-card');
    this.bundleItems = this.querySelector('.bundle-items');
    this.checkoutButton = this.querySelector('#checkout-button');
    this.bundlePriceElement = this.querySelector('#bundle-price');
    this.finalPriceElement = this.querySelector('#final-price');
    this.deliveryFrequency = this.querySelector('.delivery-frequency');
    this.subscriptionBenefits = this.querySelector('.subscription-benefits');
    this.bundleSavings = this.querySelector('.bundle-savings');


    this.addEventListeners();
    this.updatePricing();
    this.updateBundleSummary();
  }

  addEventListeners() {
    this.bundleSizeRadios = this.querySelectorAll('input[name="bundle-size"]');
    this.purchaseTypeRadios = this.querySelectorAll('input[name="purchase-type"]');
  
    this.bundleSizeRadios.forEach(radio => {
      radio.addEventListener('change', (e) => {
        this.bundleSize = parseInt(e.target.value);
        this.updatePricing();
        this.updateBundleSummary();
        this.updateFrequency();
      });
    });
  
    this.purchaseTypeRadios.forEach(radio => {
      radio.addEventListener('change', (e) => {
        this.isSubscription = e.target.value === 'subscribe';
        this.subscriptionBenefits.style.display = this.isSubscription ? 'block' : 'none';
        this.updatePricing();
        this.updateFrequency();
      });
    });
  
    this.productCards.forEach(card => {
      this.addProductCardListeners(card);
    });
  
    this.checkoutButton.addEventListener('click', () => {

      if (window.innerWidth <= 500) {
        this.showBundleSummary();
      } else {
      console.log('Bundle Contents:', this.bundleContents);
      }
    });
  }

  showBundleSummary() {
    document.querySelector('.bundle-items').classList.add('active');
    document.querySelector('.subscription-benefits').classList.add('active');
  }

  updateFrequency = () => {
    let frequency = 2
    if (this.bundleSize === 3) {
      frequency = 2
    } else if (this.bundleSize === 6) {
      frequency = 3
    } else if (this.bundleSize === 12) {
      frequency = 4
    }
    this.deliveryFrequency.innerHTML = `✔ delivered every ${frequency} months`
  }

  updatePricing() {
    
    let discount = 0;

    if (this.bundleSize === 6) discount += 0.05;
    if (this.bundleSize === 12) discount += 0.10;
    if (this.isSubscription) discount += 0.10;

    
    this.basePrice = this.bundleSize * 8
    this.finalPrice = this.basePrice * (1 - discount);

    if (this.basePrice !== this.finalPrice) {
      this.bundlePriceElement.textContent = `$${this.basePrice.toFixed(2)}`;
      this.finalPriceElement.textContent = `$${this.finalPrice.toFixed(2)}`;
    } else {
      this.bundlePriceElement.textContent = ``;
      this.finalPriceElement.textContent = `$${this.finalPrice.toFixed(2)}`;
    }

    if (discount === 0) {
      this.bundleSavings.innerHTML = `&nbsp;`
      this.bundleSavings.style.visibility = `hidden`
    } else {
      this.bundleSavings.style.visibility = `visible`
      this.bundleSavings.textContent = `You Save ${Math.floor(discount * 100)}%`
    }
  }

  updateBundleSummary() {
    this.bundleItems.innerHTML = '';
    let totalItems = 0;
  
    for (const [variantId, quantity] of Object.entries(this.bundleContents)) {
      const card = this.querySelector(`.product-card[data-variant-id="${variantId}"]`);
      const title = card.querySelector('h3').textContent;
      const image = card.querySelector('img').src;
  
      const li = document.createElement('li');
      li.innerHTML = `
        <img src="${image}" alt="${title}">
        <span>${title}</span>
        <div class="quantity-selector">
          <button class="quantity-minus">-</button>
          <span class="quantity-count">${quantity}</span>
          <button class="quantity-plus">+</button>
        </div>
      `;
  
      // Add event listeners to the new quantity buttons
      const minusButton = li.querySelector('.quantity-minus');
      const plusButton = li.querySelector('.quantity-plus');
      const quantitySpan = li.querySelector('.quantity-count');
  
      minusButton.addEventListener('click', (e) => this.updateItemQuantity(e, variantId, -1));
      plusButton.addEventListener('click', (e) => this.updateItemQuantity(e, variantId, 1));
  
      this.bundleItems.appendChild(li);
  
      totalItems += quantity;
    }
  
    this.updateCheckoutButton(totalItems);
  }

  triggerQuantityWarning(e) {
    let quantityWarning = e.target.parentElement.parentElement.querySelector('.quantity-warning')
    quantityWarning.innerHTML = 'Your bundle is full! Please increase your bundle size if you want to add more bars.'
    quantityWarning.style.display = "block";
    e.target.disabled = true;
    setTimeout(() => {
      quantityWarning.innerHTML = ""
      quantityWarning.style.display = "none";
      e.target.disabled = false;
    }, 3000)
    
  }
  
  updateItemQuantity(e, variantId, change) {
    if (this.bundleQuantity === this.bundleSize && change === 1) {
      this.triggerQuantityWarning(e)
    } else {
      this.bundleQuantity += change;
      const newQuantity = this.bundleContents[variantId] + change;
      const card = this.querySelector(`.product-card[data-variant-id="${variantId}"]`);
      console.log(card)
      const cardQuantityElement = card.querySelector('.quantity-count');
      const listItem = this.bundleItems.querySelector(`li:has(img[alt="${card.querySelector('h3').textContent}"])`);
      const listQuantityElement = listItem ? listItem.querySelector('.quantity-count') : null;
    
      if (newQuantity > 0) {
        this.bundleContents[variantId] = newQuantity;
        cardQuantityElement.textContent = newQuantity;
        if (listQuantityElement) listQuantityElement.textContent = newQuantity;
      } else {
        delete this.bundleContents[variantId];
        card.classList.remove('active');
        card.querySelector('.add-to-bundle').style.display = 'block';
        card.querySelector('.quantity-selector').style.display = 'none';
        if (listItem) this.bundleItems.removeChild(listItem);
      }
    
      this.updatePricing();
      this.updateCheckoutButton();
    }
  }
  
  updateCheckoutButton() {
    const totalItems = Object.values(this.bundleContents).reduce((sum, quantity) => sum + quantity, 0);
    const remainingItems = this.bundleSize - totalItems;

    if (remainingItems > 0) {
      this.checkoutButton.disabled = true;
      this.checkoutButton.textContent = `Please add ${remainingItems} more bar${remainingItems > 1 ? 's' : ''}`;
    } else {
      this.checkoutButton.textContent = `Go to Checkout - $${this.finalPrice.toFixed(2)}`;  
      this.checkoutButton.disabled = false;
    }
  
  }
  
  addProductCardListeners(card) {
    const addButton = card.querySelector('.add-to-bundle');
    const quantitySelector = card.querySelector('.quantity-selector');
    const minusButton = card.querySelector('.quantity-minus');
    const plusButton = card.querySelector('.quantity-plus');
    const variantId = card.dataset.variantId;
  
    addButton.addEventListener('click', () => {
      if (this.bundleQuantity === this.bundleSize && change === 1) {
        this.triggerQuantityWarning(e)
        console.log('nope')
      } else {
        card.classList.add('active');
        addButton.style.display = 'none';
        quantitySelector.style.display = 'flex';
        this.bundleContents[variantId] = 1;
        this.bundleQuantity += 1;
        this.updateBundleSummary();
      }
    });
  
    minusButton.addEventListener('click', (e) => this.updateItemQuantity(e, variantId, -1));
    plusButton.addEventListener('click', (e) => this.updateItemQuantity(e, variantId, 1));
  }
}

customElements.define('bundle-builder', BundleBuilder);